export const convertFilename = (text: string, date: Date) => {
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${text + "-" + yyyy + mm + dd}`;
};
